<template>
  <b-alert v-if="status === 'Pass'" variant="success" show>
    <b-row>
      <b-col class="alert-link">
        {{ title }}
      </b-col>
      <div
        id="svgNext"
        class="float-right"
        style="background-color: #fab414;overflow: hidden;"
      >
        <b-button
          class="svgButton2"
          target="_blank"
          :to="'/knowledge-base/' + code.toLowerCase() + '/'"
        />
      </div>
    </b-row>
  </b-alert>
  <b-alert v-else variant="danger" show>
    <b-row>
      <b-col class="alert-link">
        {{ title }}
      </b-col>
      <div
        id="svgNext"
        class="float-right"
        style="background-color: #fab414;overflow: hidden;"
      >
        <b-button
          class="svgButton2"
          target="_blank"
          :to="'/knowledge-base/' + code.toLowerCase() + '/'"
        />
      </div>
    </b-row>
  </b-alert>
</template>

<script>
export default {
  props: {
    status: { type: String, default: '' },
    title: { type: String, default: '' },
    code: { type: String, default: '' }
  }
}
</script>

<style scoped>
#svgNext {
  width: 66px;
  height: inherit;
  background: url(../static/images/right-arrow.svg) center no-repeat;
}
.alert-link {
  align-self: center;
  margin: 8px;
  padding-left: 25px;
}
.alert {
  padding: 0px;
  padding-right: 10px;
  overflow: hidden;
}
.svgButton2 {
  height: 100%;
  width: inherit;
  background-color: transparent !important;
  border-style: none !important;
  cursor: pointer;
}
.btn:focus,
.btn:active {
  outline: none !important;
  box-shadow: none !important;
}
</style>
